import { useNavigate } from "react-router-dom";
import { UserPlus, Upload, GitMerge } from "lucide-react";

export function ContactNavMenu() {
  const navigate = useNavigate();

  const items = [
    { label: "Add Contact", icon: UserPlus, action: () => navigate("/contacts?new=1") },
    { label: "Import", icon: Upload, action: () => navigate("/contacts?import=1") },
    { label: "De-duplicate", icon: GitMerge, action: () => navigate("/duplicates") },
  ];

  return (
    <div className="min-w-[180px]">
      {items.map((item) => {
        const Icon = item.icon;
        return (
          <div
            key={item.label}
            onClick={item.action}
            className="flex items-center gap-2 text-sm py-1.5 px-2 rounded hover:bg-accent cursor-pointer"
          >
            <Icon className="h-3.5 w-3.5 text-muted-foreground" />
            <span>{item.label}</span>
          </div>
        );
      })}
    </div>
  );
}
